import { render, staticRenderFns } from "./data64.vue?vue&type=template&id=530be504&scoped=true"
import script from "./data64.vue?vue&type=script&lang=js"
export * from "./data64.vue?vue&type=script&lang=js"
import style1 from "./data64.vue?vue&type=style&index=1&id=530be504&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530be504",
  null
  
)

export default component.exports